import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useUserData } from '../../../hooks'
import { isStaffUser } from '../../../utils/user'
import { getFieldVariables } from '../FieldVariable.api'
import { FieldVariableContext } from '../FieldVariable.context'

function FieldVariableProvider({ children, entity }) {
  const currentUser = useUserData()

  const [fieldVariables, setFieldVariables] = useState(EMPTY_OBJECT)

  const canViewFieldVariables = isStaffUser(currentUser)

  useEffect(() => {
    if (canViewFieldVariables) {
      getFieldVariables({ entity })
        .then(response => {
          if (response?.data) {
            setFieldVariables(response.data)
          }
        })
        .catch(console.error)
    }
  }, [canViewFieldVariables, entity])

  return (
    <FieldVariableContext value={fieldVariables}>
      {children}
    </FieldVariableContext>
  )
}

export default FieldVariableProvider
